import React, { useState } from "react";

const MedicalMinds = () => {
  const leftProfiles = [
    {
      name: "Dr Dhanya Prabhu Ramadas",
      role: "Consultant Family Physician",
      experience: "17+ Years of Experience",
      bio: "Dr. Dhanya Prabhu Ramadas is a compassionate and dedicated board-certified Family Physician with over 17 years of experience.​",
      image: "/images/new-website/doctor/dhanya-prabhu.webp",
    },

    // {
    //   name: "Dr Shweta Goyal",
    //   role: "Consultant Physician & Diabetes Expert",
    //   experience: "14+ Years of Experience",
    //   image: "/images/new-website/doctor/dr-shwetha-new.webp",
    // },

    {
      name: "Dr Rekha Venugopal",
      role: "Consultant Gynaecologist and Fertility Specialist",
      experience: "13+ Years of Experience",
      image: "images/new-website/doctor/Dr. Rekha.webp",
    },

    {
      name: "Dr Sangita Sutradhar",
      role: "Senior Family Physician",
      experience: "18+ Years of Experience",
      image: "images/new-website/doctor/dr-sangitha.webp",
    },

       {
      name: "Dr Sunila Venikar",
      role: "Consultant Physician",
      experience: "25+ Years of Experience",
      image: "images/new-website/doctor/dr-sunila-venikar.webp",
    },

  ];

  const rightProfiles = [
    {
      name: "Rekha Prabhu",
      role: "Consultant Nutritionist",
      experience: "22+ Years of Experience",
      image: "images/new-website/about-page/Rekha (1).webp",
    },

    {
      name: "Dr Preeti Surana (PT)",
      role: "Senior Physiotherapist",
      experience: "20+ Years of Experience",
      image: "/images/new-website/doctor/drpreethi.webp",
    },

    {
      name: "Arpitha Mirchandani",
      role: "Senior Psychologist",
      experience: "17+ Years of Experience",
      image: "images/arpitha-mirchandani.webp",
    },

    {
      name: "Roshan Madhusudhan Suvarna",
      role: "Exercise Specialist",
      experience: "9+ Years of Experience",
      image: "images/new-website/doctor/Roshan-bh.webp",
    },
  ];

  const additionalLeftProfiles = [

    // {
    //   name: "Dr Pooja Ghosh",
    //   role: "Consultant Physician",
    //   experience: "9+ Years of Experience",
    //   image: "images/new-website/doctor/pooja-ghosh.webp",
    // },
    {
      name: "Dr Sunil BM",
      role: "Consultant Physician",
      experience: "7+ Years of Experience",
      image: "images/new-website/doctor/Dr-sunil-bm.webp",
    },
    {
      name: "Dr Eragul S",
      role: "Consultant Physician",
      experience: "6+ Years of Experience",
      image: "images/new-website/doctor/dr-eragul.webp",
    },
    {
      name: "Dr Sesha Padmanaban",
      role: "Consultant Physician",
      experience: "5+ Years of Experience",
      image: "images/new-website/doctor/Dr. Padmanabham.webp",
    },
    {
      name: "Dr Grishma Prabhu Pai",
      role: "Consultant Physiotherapist",
      experience: "3+ Years of Experience",
      image: "/images/new-website/doctor/physiotherapy/dr. grishma prabhu pai.webp",
    },    
    {
      name: "Dr Leena.P",
      role: "Consultant Physiotherapist",
      experience: "2.5+ Years of Experience",
      image: "/images/new-website/doctor/physiotherapy/Dr. leena P.webp",
    },   
    {
      name: "Dr. Shweta Mahapatra (PT)",
      role: "Consultant Physiotherapist",
      experience: "2.2+ Years of Experience",
      image: "/images/new-website/doctor/physiotherapy/dr shweta mahapatra.webp",
    },    
    {
      name: "Roshani Karki",
      role: "Consultant Physiotherapist",
      experience: "2 Years of Experience",
      image: "/images/new-website/doctor/physiotherapy/roshani-karki.webp",
    },    
    {
      name: "Dr. Samuel Paswan ",
      role: "Consultant Physiotherapist",
      experience: "2 Years of Experience",
      image: "/images/new-website/doctor/physiotherapy/dr. samuel paswan.webp",
    },   
    {
      name: "Dr.Akshatha N",
      role: "Consultant Physiotherapist",
      experience: "2 Years of Experience",
      image: "/images/new-website/doctor/physiotherapy/dr. akshatha N.webp",
    },    

    {
      name: "Dr.Aditi Kankaria (PT)",
      role: "Consultant Physiotherapist",
      experience: "1 Year of Experience",
      image: "/images/new-website/doctor/physiotherapy/dr. aditi kankaria.webp",
    },    

    {
      name: "Dr Sathya G (PT)",
      role: "Consultant Physiotherapist",
      experience: "8 Months of Experience",
      image: "/images/new-website/doctor/physiotherapy/Dr. Sathya G.webp",
    },    

  ];

  const additionalRightProfiles = [

    {
      name: "Dr. Suneetha Chada (PT)",
      role: "Consultant Physiotherapist",
      experience: "15+ Years of Experience",
      image: "/images/new-website/doctor/physiotherapy/Dr. Sunita Chada.webp",
    },

    // {
    //   name: " Dr. Chetan Parasar (PT)",
    //   role: "Consultant Physiotherapist",
    //   experience: "17+ Years of Experience",
    //   image: "/images/new-website/doctor/physiotherapy/dr. chetan prasar.webp",
    // },

    {
      name: "Suman Krishnaraj",
      role: "Senior Clinical Nutritionist",
      experience: "9+ Years of Experience",
      image: "images/new-website/about-page/suman-krishnaraj.webp",
    },

    {
      name: "Sanjay Karanth",
      role: "Yoga Therapist",
      experience: "6+ Years of Experience",
      image: "images/new-website/doctor/Sanjay-Karanth.webp",
    },
    {
      name: "Naga Sushmitha",
      role: "Yoga Therapist",
      experience: "5+ Years of Experience",
      image: "images/new-website/doctor/Naga-sushmitha.webp",
    },
    // {
    //   name: "Aravinda HR",
    //   role: "Senior Audiologist",
    //   experience: "8+ Years of Experience",
    //   image: "images/new-website/about-page/Arvind.webp",
    // },
    // {
    //   name: "Aryan G",
    //   role: "Clinical Audiologist",
    //   experience: "5+ Years of Experience",
    //   image: "images/new-website/about-page/Aryan-G.webp",
    // },
    // {
    //   name: "Shravya Shalini I",
    //   role: "Clinical Audiologist",
    //   experience: "3+ Years of Experience",
    //   image: "images/new-website/about-page/shravya-shalini.webp",
    // },
    {
      name: "Hemanth B M",
      role: "Fitness Coach / Exercises Specialist",
      experience: "7+ Years of Experience",
      image: "images/new-website/doctor/Hemanth-B-M.webp",
    },
    {
      name: "Dr. G R Sharmiya",
      role: "Consultant Physiotherapist",
      experience: "7+ Years of Experience",
      image: "/images/new-website/doctor/physiotherapy/Dr. GR Sharmiya.webp",
    },

    {
      name: "Dr. Navya Sindhura (PT)",
      role: "Consultant Physiotherapist",
      experience: "6+ Years of Experience",
      image: "/images/new-website/doctor/physiotherapy/dr navya sindhura.webp",
    },

    {
      name: "Dr. Madhu K (PT)",
      role: "Consultant Physiotherapist",
      experience: "6+ Years of Experience",
      image: "/images/new-website/doctor/physiotherapy/Madhu k.webp",
    },

    {
      name: "Dr. Jayakumar k",
      role: "Consultant Physiotherapist",
      experience: "5+ Years of Experience",
      image: "/images/new-website/doctor/physiotherapy/dr. jayakumar.webp",
    },
    {
      name: "Dr. Akshaya",
      role: "Consultant Physiotherapist",
      experience: "3+ Years of Experience",
      image: "/images/new-website/doctor/physiotherapy/dr.akshaya.webp",
    },
    
  ];

  const [visibleLeftProfiles, setVisibleLeftProfiles] = useState(leftProfiles);
  const [visibleRightProfiles, setVisibleRightProfiles] = useState(rightProfiles);
  const [isLeftExpanded, setIsLeftExpanded] = useState(false);
  const [isRightExpanded, setIsRightExpanded] = useState(false);
  const [hoveredProfile, setHoveredProfile] = useState(null);

  const handleLoadMoreLeft = () => {
    if (!isLeftExpanded) {
      setVisibleLeftProfiles([...leftProfiles, ...additionalLeftProfiles]);
    } else {
      setVisibleLeftProfiles(leftProfiles);
    }
    setIsLeftExpanded(!isLeftExpanded);
  };

  const handleLoadMoreRight = () => {
    if (!isRightExpanded) {
      setVisibleRightProfiles([...rightProfiles, ...additionalRightProfiles]);
    } else {
      setVisibleRightProfiles(rightProfiles);
    }
    setIsRightExpanded(!isRightExpanded);
  };

  return (
    <section className="medical-minds-section">
      <div className="medical-minds-container">
        {/* Left Column */}
        <div className="profiles-column colum-border">
          {visibleLeftProfiles.map((profile, index) => (
            <div
              className="profile-card"
              key={index}
              onMouseEnter={() => setHoveredProfile(profile)}
              onMouseLeave={() => setHoveredProfile(null)}
            >
              <img src={profile.image} alt={profile.name} />
              <div className="profile-details">
                <h3>{profile.name}</h3>
                <p>{profile.role}</p>
                {profile.experience && <span>{profile.experience}</span>}
              </div>
              {/* {hoveredProfile === profile && (
                <div className="profile-hover-card">
                  <p>{profile.bio}</p>
                </div>
              )} */}
            </div>
          ))}
          <div className="load-more-container mobile-only">
            <button className="load-more-button" onClick={handleLoadMoreLeft}>
              {isLeftExpanded ? "Show Less" : "Load More"}
            </button>
          </div>
        </div>

        {/* Right Column */}
        <div className="profiles-column">
          {visibleRightProfiles.map((profile, index) => (
            <div
              className="profile-card"
              key={index}
              onMouseEnter={() => setHoveredProfile(profile)}
              onMouseLeave={() => setHoveredProfile(null)}
            >
              <img src={profile.image} alt={profile.name} />
              <div className="profile-details">
                <h3>{profile.name}</h3>
                <p>{profile.role}</p>
                {profile.experience && <span>{profile.experience}</span>}
              </div>
              {/* {hoveredProfile === profile && (
                <div className="profile-hover-card">
                  <p>{profile.bio}</p>
                </div>
              )} */}
            </div>
          ))}
          <div className="load-more-container mobile-only">
            <button className="load-more-button" onClick={handleLoadMoreRight}>
              {isRightExpanded ? "Show Less" : "Load More"}
            </button>
          </div>
        </div>
      </div>

      {/* Desktop Load More Button */}
      <div className="load-more-container desktop-only">
        <button className="load-more-button" onClick={() => { handleLoadMoreLeft(); handleLoadMoreRight(); }}>
          {isLeftExpanded && isRightExpanded ? "Show Less" : "Load More"}
        </button>
      </div>
    </section>
  );
};

export default MedicalMinds;
